import {
  ConfirmationBox,
  Labeled,
  SaveBox,
  TextInput,
} from '@infotech-soe/erp-ui-kit';
import { tg } from '@infotech-soe/metaschema';
import React, { memo, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { useStyles as useDialogStyles } from '../dialogs/styles';

import { messages } from './messages';
import type { PivotSavePresetFormProps } from './types';

const PivotSavePresetForm = ({
  currentPreset,
  open,
  presetNames,
  onCancel,
  onSavePreset,
}: PivotSavePresetFormProps): React.JSX.Element => {
  const [isOpenedConfirm, setIsOpenedConfirm] = useState(false);
  const [name, setName] = useState(currentPreset);
  const dialogClasses = useDialogStyles();
  const { formatMessage } = useIntl();

  const handleSubmit = useCallback(() => {
    if (tg.isNotBlankString(name) && presetNames.includes(name)) {
      setIsOpenedConfirm(true);
      return;
    }
    onSavePreset(name);
  }, [name, onSavePreset, presetNames]);

  const handleConfirmSubmit = useCallback(() => {
    setIsOpenedConfirm(false);
    tg.isNotBlankString(name) && onSavePreset(name);
  }, [name, onSavePreset]);

  const handleCancelSubmit = useCallback(() => {
    setIsOpenedConfirm(false);
  }, []);

  return (
    <>
      <SaveBox
        open={open}
        height="auto"
        width={360}
        saveButtonDisabled={!tg.isNotBlankString(name)}
        title={formatMessage(messages.savePreset)}
        onCancel={onCancel}
        onClose={onCancel}
        onSave={handleSubmit}
      >
        <Labeled label={formatMessage(messages.label)}>
          <TextInput
            value={name}
            onChange={setName}
            onSubmit={(v: string) => tg.isNotBlankString(v) && handleSubmit()}
          />
        </Labeled>
      </SaveBox>
      <ConfirmationBox
        className={dialogClasses.dialog}
        open={isOpenedConfirm}
        height={120}
        width={360}
        noChildrenWrap
        noCloseButton={false}
        title={formatMessage(messages.savePreset)}
        onCancel={handleCancelSubmit}
        onConfirm={handleConfirmSubmit}
        onClose={handleCancelSubmit}
      >
        <div className="m-px-xl">
          {formatMessage(messages.overwritePreset, { name })}
        </div>
      </ConfirmationBox>
    </>
  );
};

export default memo(PivotSavePresetForm);
